import {
  apiPostConfig,
  apiPostFileConfig,
  fetchData
} from '../utils/data';

import {
  isLoggedIn,
  getSessionToken,
  getSessionUser
} from '../persistance/storage';

import {
  KEY,
  ASYNC_REQUEST,
  ASYNC_REQUEST_COMPLETE,
  ASYNC_REQUEST_ERROR,
  ASYNC_REQUEST_UPDATE_SUCCESS,
  ASYNC_REQUEST_ACTION_FAILED
} from '../constants/constants';

import { SERVER_FAILURE_ERROR } from '../constants/messages';


export function retrieveData(endpoint, actionType, id=null){
  return dispatch => {
    const headers = requestHeaders(isLoggedIn(KEY));

    dispatch({ type: ASYNC_REQUEST });

    return fetchData(endpoint, headers)
      .then( data => dispatch({ type: actionType, data, id }) )
      .catch( error => dispatch({ type: ASYNC_REQUEST_ERROR, error: error.message }) )
      .then( () => dispatch({ type: ASYNC_REQUEST_COMPLETE }) );
  };
}

export function createData(endpoint, actionType, data){
  const config = apiPostConfig('POST', requestHeaders(isLoggedIn(KEY)), data);

  return processData(endpoint, config, actionType);
}

export function updateData(endpoint, actionType, data, id){
  const config = apiPostConfig('PATCH', requestHeaders(isLoggedIn(KEY)), data);

  return processData(endpoint, config, actionType, id);
}

export function deleteData(endpoint, actionType, data, id){
  const config = apiPostConfig('DELETE', requestHeaders(isLoggedIn(KEY)), data);

  return processData(endpoint, config, actionType, id);
}

export function createDataFile(endpoint, actionType, data){
  const config = apiPostFileConfig('POST', requestHeaders(isLoggedIn(KEY)), data);

  return processData(endpoint, config, actionType);
}

export function updateDataFile(endpoint, actionType, data){
  const config = apiPostFileConfig('PUT', requestHeaders(isLoggedIn(KEY)), data);

  return processData(endpoint, config, actionType);
}

function processData(endpoint, config, actionType, id=null){
  return dispatch => {
    dispatch({ type: ASYNC_REQUEST });

    return fetch(endpoint, config)
      .then( res => {
        if(res.ok){
          return res.json();
        }
        return parseResponseError(res).then(error => { throw error });
      })
      .then( data => {
        dispatch({ type: ASYNC_REQUEST_UPDATE_SUCCESS })
        dispatch({ type: actionType, data, id })
      })
      .catch( error => dispatch({ type: ASYNC_REQUEST_ACTION_FAILED, errMsg: toErrorMessage(error) }) )
      .then( () => dispatch({ type: ASYNC_REQUEST_COMPLETE }) );
  };
}

// Errors thrown by reducers or fetch are Error instances, which can't be kept in the store
function toErrorMessage(error){
  if(!error) return { error: SERVER_FAILURE_ERROR };
  if(error instanceof Error) return { error: error.message || SERVER_FAILURE_ERROR };
  return error;
}

function parseResponseError(res){
  return res.text().then((text) => {
    if(!text){
      return { error: SERVER_FAILURE_ERROR };
    }

    try {
      const data = JSON.parse(text);
      if(data && typeof data === 'object'){
        const error = data.error || data.errors || formatErrorPayload(data);
        const errors = data.errors || (data.error ? undefined : data);
        return { error: typeof error === 'string' ? error : formatErrorPayload(error), errors };
      }
    } catch(e) {
      // fallback to raw text when response is not JSON
    }

    return { error: text || SERVER_FAILURE_ERROR };
  });
}

function formatErrorPayload(payload){
  if(typeof payload === 'string') return payload;
  if(Array.isArray(payload)) return payload.join(', ');
  if(typeof payload === 'object'){
    return Object.keys(payload).map(key => {
      const value = payload[key];
      const valueText = Array.isArray(value) ? value.join(', ') : String(value);
      return `${key} ${valueText}`;
    }).join('. ');
  }
  return String(payload);
}

export function requestHeaders(isLoggedIn){
  if(isLoggedIn){
    let userEmail = getSessionUser(KEY);
    let userToken = getSessionToken(KEY);

    return {
      "X-USER-EMAIL" : userEmail,
      "X-USER-TOKEN" : userToken
    };
  }

  return {};
}
